"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function generatePipeline() {
    const actionMatchers = [];
    function add({ doIf, action }) {
        actionMatchers.push({
            doIf,
            action,
        });
    }
    function pipeline(resp) {
        const am = actionMatchers.find(a => a.doIf(resp));
        if (am) {
            am.action(resp);
        }
        return resp;
    }
    pipeline.add = add;
    return pipeline;
}
exports.default = generatePipeline;
//# sourceMappingURL=pipeline.js.map